export enum WorkCategory {
  CUENTO = "Cuento",
  NO_FICCION = "No ficción",
  TEATRO = "Teatro",
  RADIOTEATRO = "Radioteatro",
  TODOS = "Todos",
}

export enum CategoryToName {
  Cuento = "CUENTO",
  "No ficción" = "NO_FICCION",
  Teatro = "TEATRO",
  Radioteatro = "RADIOTEATRO",
  Todos = "TODOS",
}

export enum WorkCategoryName {
  CUENTO = "CUENTO",
  NO_FICCION = "NO_FICCION",
  TEATRO = "TEATRO",
  RADIOTEATRO = "RADIOTEATRO",
  TODOS = "TODOS",
}
